import { useMediaQuery } from "@mui/material";
import DefaultButton from "../../../../../..//components/buttons/default-button";
import DefaultText from "../../../../../../components/typography/default-text";
import styles from "./styles.module.css";
import { sxTextMinorHomeBanner } from "./sxProps";

const MinorHomeBanner: React.FC<{
  onClick?: () => void,
  image?: string,
  title?: string,
  subtitle?: string
}> = ({ onClick, image, title, subtitle }) => {

  const isMobile = useMediaQuery("(max-width: 899px)");

  return (
    <div id="minor-home-banner">
      <div className={styles["minor-banner-text"]}>
        <DefaultText zIndex={1} color={"var(--primary-white)"}
          lineHeight={isMobile ? "32px" : "48px"} size={"medium"} sx={{ fontFamily: "Montserrat-Bold" }}
        >
          {title}
        </DefaultText>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginLeft: isMobile?  "24px" : "0px" }}>
          <DefaultText zIndex={1} color={"var(--primary-white)"}
            size={"small"} sx={sxTextMinorHomeBanner}
          >
            {subtitle}
          </DefaultText>
          {onClick && 
          <DefaultButton variant={"outlined"} onClick={() => { onClick() }}>
          <span style={{ fontFamily: 'Montserrat-Regular'}}>Descubra Mais </span>
          </DefaultButton>}
        </div>
      </div>
      <img src={image} className={styles["minor-banner-image"]}
        alt={`Imagem do Banner ${title}`}
      />
    </div>
  );
};

export default MinorHomeBanner;